import { ICardLogos } from '../../interfaces';
import amexCard from '../assets/amex.svg';
import mastercardCard from '../assets/mastercard.png';
import payPalCard from '../assets/pay-pal.png';
import visaCard from '../assets/visa.svg';

const cardLogos: ICardLogos = {
  visa: visaCard,
  amex: amexCard,
  mastercard: mastercardCard,
  paypal: payPalCard,
};

export default cardLogos;
